import React from "react";
import {Grid, Typography} from "@mui/material";
import {disciplineEntreeLabelStatus} from "../../../utils/utility";


export interface GridCelulaEtapaProps {
    etapa: any
}

const GridCelulaEtapa = (p: GridCelulaEtapaProps) => {
 
    if (p.etapa.empty) {
        return (
            <React.Fragment>
                <Grid item container sx={{display:'flex', flexDirection:'row', flexWrap:'nowrap', borderWidth: '1px', borderColor: 'black', borderStyle: 'solid', borderRadius: '3px'}}>
                    <Grid item container sx={{display:'flex', flexDirection:'row', width:'100%'}}>
                    
                    </Grid>
                </Grid>
            </React.Fragment>
        );
    }
    
    return (
        <React.Fragment>
            <Grid item container sx={{display:'flex', flexDirection:'row', flexWrap:'wrap', borderWidth: '1px', borderColor: 'black', borderStyle: 'solid', borderRadius: '3px', padding:'3px'}}>
                <Grid item container sx={{display:'flex', flexDirection:'row', flexWrap: 'nowrap', width:'100%', justifyContent: 'space-between'}}>
                   <Typography variant="caption" component="div" sx={{ fontWeight: 'normal' }}>{p.etapa.dmod.Description}</Typography>
                    <Typography variant="caption" component="div" sx={{ fontWeight: 'normal' }}>CH:{p.etapa.dmod.WorkloadTotal}</Typography>
                    <Typography variant="caption" component="div" sx={{ fontWeight: 'normal' }}>CP:{p.etapa.dmod.WorkloadPresential}</Typography>
                </Grid>
                <Grid item container sx={{display:'flex', flexDirection:'row', flexWrap:'wrap', justifyContent:'space-around'}}>
                    {
                        p.etapa && p.etapa.dees &&
                        p.etapa.dees
                            .filter( (f: any) =>  [ 2,3,4,5,7 ].indexOf(f.Status) === -1 )
                            .map( (m: any) => {
                            return (
                                <React.Fragment>
                                <Grid item container  sx={{display:'flex', flexDirection:'row', flexWrap:'nowrap', justifyContent:'space-around'}}>
                                    <Typography variant="caption"  sx={{ fontWeight: 'normal' }}>{m.FrequenciaPercentual}%</Typography>
                                    <Typography variant="caption"  sx={{ fontWeight: 'normal' }}>{m.Nota}</Typography>
                                </Grid>
                                <Grid item container  sx={{display:'flex', flexDirection:'row', flexWrap:'nowrap', justifyContent:'space-between'}}>
                                    <Typography variant="caption"  sx={{ fontWeight: 'normal' }}>{disciplineEntreeLabelStatus(m.Status)}</Typography>
                                </Grid>
                                </React.Fragment>
                            )
                        })
                    }
                </Grid>
            </Grid>
        </React.Fragment>
    );
}

export default (GridCelulaEtapa);
